module.exports = __webpack_public_path__ + "media/images/wanderweb/wanderweb-69c22e3f103242d1624ee50ebd033629.jpg";